class HedgehogCountdown extends HTMLElement {
  connectedCallback() {
    const target = Date.parse(this.dataset.target || '');
    if (Number.isNaN(target)) {
      this.hidden = true;
      return;
    }

    const render = () => {
      const remaining = Math.max(0, target - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining / 3600000) % 24);
      const minutes = Math.floor((remaining / 60000) % 60);
      const seconds = Math.floor((remaining / 1000) % 60);

      this.querySelector('[data-days]').textContent = `${days}d`;
      this.querySelector('[data-hours]').textContent = `${hours}h`;
      this.querySelector('[data-minutes]').textContent = `${minutes}m`;
      this.querySelector('[data-seconds]').textContent = `${seconds}s`;
    };

    render();
    this.timer = window.setInterval(render, 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }
}

if (!customElements.get('hedgehog-countdown')) {
  customElements.define('hedgehog-countdown', HedgehogCountdown);
}

